import React from 'react';
import AuthGuard from './AuthGuard';
import OrganizationGuard from './OrganizationGuard';
import PermissionGuard from './PermissionGuard';
import { debugLog } from '../../../utils/debugLogger';

interface GuardChainProps {
  children: React.ReactNode;
}

/**
 * GuardChain - Combines all guards in the correct order
 * 
 * Flow: AuthGuard → OrganizationGuard → PermissionGuard → App Content
 * 
 * Each guard has a single responsibility and clear failure path:
 * - AuthGuard fails → Redirect to sign-in
 * - OrganizationGuard fails → Show onboarding or pending page
 * - PermissionGuard fails → Show access denied (future)
 */
export default function GuardChain({ children }: GuardChainProps) {
  // DEBUG FLAGS: Set DEBUG_GUARDS to true to enable authentication guard logging
  const DEBUG_GUARDS = false;
  if (DEBUG_GUARDS && import.meta.env.DEV) {
    console.log('🔗 GuardChain: Starting authentication flow');
  }
  
  return (
    <AuthGuard>
      <OrganizationGuard>
        <PermissionGuard>
          {children}
        </PermissionGuard>
      </OrganizationGuard>
    </AuthGuard>
  );
}
